import { render, staticRenderFns } from "./LicenseIdentifier.vue?vue&type=template&id=61b4a5b6&scoped=true&lang=pug"
import script from "./LicenseIdentifier.vue?vue&type=script&lang=js"
export * from "./LicenseIdentifier.vue?vue&type=script&lang=js"
import style0 from "./LicenseIdentifier.vue?vue&type=style&index=0&id=61b4a5b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b4a5b6",
  null
  
)

export default component.exports